import { Outlet, createFileRoute } from "@tanstack/react-router";

import { memberLayoutCrumb } from "@/lib/crumb-resolvers";
import { requireRole } from "@/lib/route-guards";

// crumb は案件サブツリー (`/member/$id...`) でだけ出自セクションを出す。
// 企業サブツリー (`/member/companies...`) では companies layout が `企業一覧` を出すので
// ここは null を返す (memberLayoutCrumb 内で pathname を見て分岐)。
export const Route = createFileRoute("/_authenticated/member")({
  staticData: { crumb: memberLayoutCrumb() },
  beforeLoad: requireRole("MEMBER"),
  component: () => <Outlet />,
});
